import { apiPostAuth, apiPutAuth, apiGetAuth, apiDeleteAuth } from '@/utils/api'
import { API_ROLE } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  role_list: {
    isLoading: false,
    data: false
  },
  detail_role: {
    isLoading: false,
    data: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  }
  
}

const mutations = {
  "SET_ROLE_LIST": (state, payload) => {
    state.role_list = payload
  },
  "SET_DETAIL_ROLE": (state, payload) => {
    state.detail_role = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getRoleList(context, payload) {
    try {
      context.commit('SET_ROLE_LIST', {isLoading: true})
      const response = await apiGetAuth(API_ROLE.LIST, payload)
      context.commit('SET_ROLE_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_ROLE_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailRole(context, payload) {
    try {
      context.commit('SET_DETAIL_ROLE', {isLoading: true})
      const response = await apiGetAuth(API_ROLE.BY_ID(payload))
      context.commit('SET_DETAIL_ROLE', {
        isLoading: false,
        data: response.data.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_ROLE', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async createRole (context, payload) {
    try {
      const response = await apiPostAuth(API_ROLE.CREATE_ROLE, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateRole (context, payload) {
    try {
      const response = await apiPutAuth(API_ROLE.BY_ID(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async deleteRole(context, payload) {
    try {
      const response = await apiDeleteAuth(API_ROLE.BY_ID(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_role_list: state => {
    return state.role_list
  },
  get_detail_role: state => {
    return state.detail_role
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
